import { useMutation } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";

interface BillingPortalResponse {
  url: string;
}

export const fetchBillingPortal = async (): Promise<BillingPortalResponse> => {
  const response = await axios.get<BillingPortalResponse>("/billing/portal");
  return response.data;
};

export const useBillingPortal = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: fetchBillingPortal,
  });

  return {
    getBillingPortal: mutateAsync,
    isLoading: isPending,
    error,
  };
};
